export default __webpack_public_path__ + "static/media/visibility.768700f6.svg";